import { render, staticRenderFns } from "./report-results-filtering.vue?vue&type=template&id=b1ad72ca&"
import script from "./report-results-filtering.vue?vue&type=script&lang=ts&"
export * from "./report-results-filtering.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports